<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zatwierdź"
    title="Usuwanie konta"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="deleteOwn"
    @close="close"
  >
    <p>
      Podaj hasło w celu weryfikacji
    </p>

    <w-input type="password" :model="$schema.password" />

    <p>
      UWAGA! Usunięcie konta spowoduje utratę dostępu do wszystkich powiązanych z nim danych.
    </p>
  </w-modal>
</template>

<script>
import { formMixin } from '@/mixins/form';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/confirmDeleteAccount.schema';
import { serverError } from '@/utils/serverError';

// @vuese
// Modal usuwania konta
// @group modals
export default {
  mixins: [modalMixin, notificationsMixin, formMixin],
  schema,
  methods: {
    // @vuese
    // Wysłanie maila z potwierdzeniem usunięcia konta
    deleteOwn() {
      if (!this.$schema.$validateAll().length) {
        this.$store
          .dispatch('auth/deleteOwn', this.$schema.password.$getData())
          .then(() => this.$emit('close', true))
          .catch(error => this.notifyError(serverError(error)));
      }
    }
  }
};
</script>
